import { Node, LeafNode, Permission } from './types';

const getLeaf = (permission: Permission): LeafNode => ({
    type: 'leaf-node',
    permission,
});

export const permissionTree: Node[] = [
    {
        type: 'group-node',
        nodeType: 'medical-data',
        subNodes: [
            getLeaf('idsAndInfo'),
            getLeaf('medications'),
            getLeaf('conditions'),
            getLeaf('allergies'),
            getLeaf('visits'),
            /*
            getLeaf('imaging'),
            */
            getLeaf('procedures'),
            getLeaf('vaccinations'),
            getLeaf('labs'),
            getLeaf('careTeam'),
            getLeaf('reports'),
            getLeaf('files'),
        ],
    },
    getLeaf('patientPortals'),
    getLeaf('collaborators'),
];
